import { render, staticRenderFns } from "./StatementPolicyCancel.vue?vue&type=template&id=2656901b&scoped=true&"
import script from "./StatementPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./StatementPolicyCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656901b",
  null
  
)

export default component.exports